export default __webpack_public_path__ + "static/media/FreeDelivery.c3aa1325.svg";